import { cn } from '@newfront-insurance/core-ui/v2';
import type { ReactNode } from 'react';

interface ChatInputToolbarProps {
  children: ReactNode;
  className?: string;
}

/**
 * Toolbar component for chat input actions.
 * Accepts children for flexible composition of toolbar buttons and actions.
 *
 * @example
 * ```tsx
 * <ChatInputToolbar>
 *   <div className="flex items-center gap-2">
 *     <ChatAttachments />
 *   </div>
 *   <div className="flex items-center gap-2">
 *     <SendButton />
 *   </div>
 * </ChatInputToolbar>
 * ```
 */
export function ChatInputToolbar({ children, className }: ChatInputToolbarProps) {
  return <div className={cn('flex w-full flex-1 items-center p-2', className)}>{children}</div>;
}
